import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: [remCalc(24), remCalc(24), remCalc(24), remCalc(40)],
            width: '100%',
        },
        header: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
        },
        checkIconBox: {
            backgroundColor: 'text.success',
            border: 'large',
            borderColor: 'text.success',
            borderRadius: 'full',
            alignSelf: 'center',
            borderStyle: 'solid',
            boxSize: 'iconsSize.xlarge',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        checkIcon: {
            boxSize: 'iconsSize.xlarge',
            color: 'text.inverse',
        },
        headerInner: {
            display: 'flex',
            paddingTop: remCalc(24),
            paddingBottom: [0, 0, 0, remCalc(24)],
            flexDirection: 'column',
            gap: remCalc(16),
            alignSelf: 'stretch',
            alignItems: 'center',
        },
        title: {
            textStyle: 'head-xlarge',
            fontWeight: 'medium',
            color: 'text.default',
            textAlign: 'center',
        },
        subtitle: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'text.default',
            textAlign: 'center',
        },
        detailsOuterContainer: {
            display: 'flex',
            maxWidth: remCalc(1281),
            flexDirection: ['column', 'column', 'column', 'unset'],
            alignItems: ['flex-start', 'flex-start', 'flex-start', 'center'],
            gap: remCalc(24),
            alignSelf: ['stetch', 'stretch', 'stretch', 'unset'],
        },
        imageContainer: {
            width: ['100%', '100%', '100%', remCalc(569)],
            height: [remCalc(190), remCalc(190), remCalc(190), remCalc(290)],
            flexShrink: 0,
            justifyContent: 'center',
        },
        productImage: {
            boxSize: [remCalc(190), remCalc(190), remCalc(190), remCalc(290)],
        },
        detailsContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'center',
        },
        detailsTitle: {
            textStyle: 'head-medium',
            fontWeight: 'medium',
            color: 'text.default',
        },
        detailsDescription: {
            textStyle: 'body-medium',
            fontWeight: 'normal',
            color: 'text.default',
        },
        newUser: {
            display: 'flex',
            padding: [remCalc(24), remCalc(24), remCalc(24), remCalc(40)],
            justifyContent: ['unset', 'unset', 'unset', 'space-between'],
            flexDirection: ['column', 'column', 'column', 'unset'],
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            gap: [remCalc(40), remCalc(40), remCalc(40), 'auto'],
            borderRadius: remCalc(8),
            background: 'background.light',
        },
        prosContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: ['stetch', 'stretch', 'stretch', 'unset'],
        },
        labelsContainer: {
            display: 'flex',
            width: ['100%', '100%', '100%', remCalc(688)],
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(8),
        },
        prosTitle: {
            textStyle: 'body-large',
            fontWeight: 'normal',
            color: 'text.default',
        },
        prosDescription: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.default',
        },
        iconsContainer: {
            display: 'flex',
            width: ['100%', '100%', '100%', remCalc(688)],
            flexDirection: 'column',
            alignItems: 'flex-start',
        },
        iconLabel: {
            display: 'flex',
            padding: `${remCalc(16)} 0`,
            flexDirection: 'row',
            alignItems: 'center',
            gap: remCalc(16),
            alignSelf: 'stretch',
            borderRadius: 0,
            borderBottom: `1px solid`,
            borderColor: 'border.light',
        },
        proIcon: {
            boxSize: remCalc(24),
        },
        infoIcon: {
            boxSize: remCalc(16),
            fill: 'transparent',
            color: 'button.text.secondary-default',
        },
        proDescription: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'text.default',
        },
    },
}
